import { DocumentType } from '../generated/prisma/enums.js';
export const PA_OBLIGATION_DOCUMENT_TYPES = [
    DocumentType.TAX_PAYMENT,
    DocumentType.INPS_CONTRIBUTION,
    DocumentType.INAIL_PREMIUM,
    DocumentType.PA_DEBT,
];
//# sourceMappingURL=document-types.js.map